import { jsx as _jsx } from "react/jsx-runtime";
import { HeadingToolbar } from '@udecode/plate';
const Toolbar = (props) => (_jsx(HeadingToolbar
// eslint-disable-next-line react/jsx-props-no-spreading
, { ...props, style: {
        margin: 0,
        padding: '0 0 8px 0',
    } }));
export default Toolbar;
//# sourceMappingURL=Toolbar.js.map